<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label="label" :label-for="formControlId">
        <template v-slot:label>
            <template v-if="label">
                {{ label }}
                <csp-form-tooltip :tooltip="tooltip"/>
            </template>
        </template>
        <b-form-checkbox :id="formControlId" v-model="data[property]" :button="button"
            :button-variant="buttonVariant"
            :disabled="isReadOnlyProperty" :name="formControlId" :required="isRequiredProperty"
            :state="validationState" :switch="asSwitch" :unchecked-value="uncheckedValue" :value="value"
            @change="emitChange">
            <template v-if="!hasLabelSlot && !overrideLabel">
                <span>
                    {{ $t('form field checkbox ' + labelPropertyValue) }}
                </span>
            </template>
            <template v-if="!hasLabelSlot && overrideLabel">
                <span>
                    {{ overrideLabel }}
                </span>
            </template>
            <slot name="label"/>
        </b-form-checkbox>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from '@components/form/FormGroupMixin';

    export default {
        mixins: [FormGroupMixin],
        props: {
            asSwitch: {
                type: Boolean,
                default: false,
            },
            buttonVariant: {
                type: String,
                default: '',
            },
            overrideLabel: {
                type: String,
                default: null,
            },
            uncheckedValue: {
                type: [String, Boolean],
                default: false,
            },
            value: {
                type: [String, Boolean],
                default: true,
            },
            button: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change'],
        computed: {
            hasLabelSlot() {
                return !!this.$slots.label;
            },
        },
        methods: {
            emitChange(value) {
                this.$emit('change', value);
            },
        },
    }
</script>
